import { graphql } from '~publish/graphql'

import { useTypedMutation } from '../../hooks/useTypedMutation'

export const MovePostToTopOfQueue = graphql(/* GraphQL */ `
  mutation MovePostToTopOfQueue($id: PostId!) {
    movePostInQueue(input: { id: $id, position: top }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
          shareMode
        }
      }
    }
  }
`)

export const MovePostToBottomOfQueue = graphql(/* GraphQL */ `
  mutation MovePostToBottomOfQueue($id: PostId!) {
    movePostInQueue(input: { id: $id, position: bottom }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
          shareMode
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useMovePostToTopOfQueue = () =>
  useTypedMutation(MovePostToTopOfQueue, (data) => data.movePostInQueue, {
    refetchQueries: ['GetPostList'],
    successTypename: 'PostActionSuccess',
  })

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useMovePostToBottomOfQueue = () =>
  useTypedMutation(MovePostToBottomOfQueue, (data) => data.movePostInQueue, {
    refetchQueries: ['GetPostList'],
    successTypename: 'PostActionSuccess',
  })
